import { ClickEvent, Image, Snackbar, TableRowDisplayEvent, Textbox } from "@mcleod/components";
import { Clipboard, ModelRow } from "@mcleod/core";
import { AutogenLayoutWireAdvanceQuickInfo } from "./autogen/AutogenLayoutWireAdvanceQuickInfo";

export class WireAdvanceQuickInfo extends AutogenLayoutWireAdvanceQuickInfo {

    tableDriverAdvanceQuickInfoOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();
        const wireCodeDescription = tableRow.findComponentById("textboxWireCodeDescription") as Textbox;
        const clipBoardImageIcon = tableRow.findComponentById("imageCopyClipBoard") as Image;
        const wireCodeId = tableRow.data.get("wire_code");
        const description = tableRow.data.get("wire_code_description");
        const display = "--" === description ? wireCodeId : `${wireCodeId} (${description})`;
        wireCodeDescription.text = display
        clipBoardImageIcon.visible = tableRow.data.get("check_code") !== "--";
        if (tableRow.index > 0) {
            tableRow.table.rows[tableRow.index - 1].borderBottomWidth = 1;
        }
    }

    imageCopyClipBoardOnClick(event: ClickEvent) {
        event.preventDefault();
        const modelRow = (event.target as any).row.data as ModelRow;
        const checkCode = modelRow.get("check_code", "");
        Clipboard.copyText(checkCode);
        Snackbar.showSnackbar("Check code copied to clipboard");
    }

}
